import { createFileRoute } from '@tanstack/react-router'
import { LibraPage } from 'pages/libra/LibraPage'
import { libraSearchParamsSchema } from 'routes/libra/-searchParams'

const selectedLibraLayout = {
  showNavbar: true,
  showSearchBar: false,
  enforceMaxWidth: false,
  enableScrolling: false,
}

const RouteComponent = () => {
  const { orgId, workflowId, ticket } = Route.useSearch()

  return <LibraPage orgId={orgId} workflowId={workflowId} ticketId={ticket} />
}

export const Route = createFileRoute('/libra/')({
  component: RouteComponent,
  validateSearch: libraSearchParamsSchema,
  staticData: {
    title: 'Libra',
  },
  beforeLoad: ({ search }) => {
    return search.orgId ? selectedLibraLayout : {}
  },
})
